import { Component, ViewChild } from '@angular/core';
import "rxjs/add/observable/forkJoin";
import { NavController, NavParams, ViewController, ModalController, LoadingController } from 'ionic-angular';
import { ChaseBetting } from '../../models/betting.model';
import { BettingService } from '../../services/betting.service';
import { AlertService } from '../../providers/alert.service';
import { LoaddingService } from '../../providers/loadding.service';
import { PageDefault } from '../PageDefault';
import { CurrIssue } from '../../models/bettingorder.dto';
import { BettingChase } from '../bettingorder/bettingchase';
// @IonicPage()
@Component({
    selector: 'page-bettingList',
    templateUrl: 'bettingList.html',
    providers: [BettingService]
})
export class BettingListPage {
    currlDollarCode: string;
    rootNavCtrl: NavController;
    cucumber: boolean;
    bettingMoney: number;
    para = {
        currIssue: new CurrIssue(),
        formatRemain: "00:00:00"
    };
    setIntervalid: any;
    bettingMoneyCount = {
        noteTotal: 0,
        BettingMoney: 0,
        IssueNo: "",
        LotteryCode: "",
        IsChaseNo: 0,
        LotteryPlayModeCode: "",
        IsStopAfterWinning: 0,//0：中奖后不追号，1：中奖后继续追号
        BettingInfoIssueList: [],
        BettingInfoIssueString: "",
        BettingItemList: [],
        BettingItemString: ""
    };//双面盘下注金额统计和注数集合
    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public viewCtrl: ViewController,
        private bettingService: BettingService,
        public modalCtrl: ModalController,
        private loadding: LoaddingService,
        private alert: AlertService
    ) {
        this.bettingMoneyCount = this.navParams.get("bettingMoneyCount");
        this.bettingMoney = this.navParams.get("bettingMoney");
    }

    ionViewWillLoad() {
    }

    ionViewDidLoad() {
        this.bettingMoneyCount.BettingItemList.forEach(r => {
        });
        this.dollarsBettingTotal();
    }
    ionViewWillEnter() {

    }
    ionViewDidEnter() {
        this.getIssue();
        let lastCtrl = this.navCtrl.last();
        if (lastCtrl.component == BettingChase) {
            this.close(false);
        }
    }
    ionViewDidLeave() {
        clearInterval(this.setIntervalid);
    }

    //弹窗关闭
    close(boolean) {
        var param = {
            isSuccess: boolean
        };
        clearInterval(this.setIntervalid);
        this.viewCtrl.dismiss(param);
    }
    //删除单条投注记录
    deleteDollarBet(res) {
        var index = this.bettingMoneyCount.BettingItemList.indexOf(res);
        this.bettingMoneyCount.BettingItemList.splice(index, 1)
        this.dollarsBettingTotal();
    }

    // 计算投注总数和总额
    dollarsBettingTotal() {
        let noteTotal = 0,
            orderNumber = 0,
            bettingMoneyTotal = 0;
        this.bettingMoneyCount.BettingItemList.forEach(s => {
            noteTotal++;
            if (this.bettingMoneyCount.LotteryPlayModeCode != "1131" && this.bettingMoneyCount.LotteryPlayModeCode != "1124") {
                orderNumber++;
                s.Position1 = JSON.stringify(orderNumber);
            }
            bettingMoneyTotal += s.BettingMoney;
        });
        this.bettingMoneyCount.noteTotal = noteTotal;
        this.bettingMoneyCount.BettingMoney = bettingMoneyTotal;
    }

    /**
    * 获取快钱玩法投注期号集合信息
    * evan 2018-05-31
    * @memberof LotteryComponent
    */
    getDollarsIssueString() {
        let issueString = "";
        this.bettingMoneyCount.BettingInfoIssueList.forEach((issue, index) => {
            issueString += issue.IssueNo + "@";
            issueString += issue.Multiple + "@";
            issueString += issue.PerPrice + "@";
            issueString += issue.BettingMoney + "|";
        })
        issueString = issueString.substr(0, issueString.length - 1);
        this.bettingMoneyCount.BettingInfoIssueString = issueString;
    }


    // 追号序列 i:IssueNo期号 m:Multiple倍数 
    dollarsChaseArray(i, m) {
        let attr = new ChaseBetting();
        attr.IssueNo = i;
        attr.Multiple = m;
        attr.PerPrice = 1;
        attr.BettingMoney = this.bettingMoneyCount.BettingMoney * m;
        this.bettingMoneyCount.BettingInfoIssueList.push(attr);
        this.getDollarsIssueString();
    }

    // 提交前将投注项转换为信用投注接口需要的字符串
    getBettingItemString() {
        let bettingString = "";
        this.bettingMoneyCount.BettingItemList.forEach((bet, index) => {
            bettingString += bet.LotteryPlayDetailCode + "@";
            bettingString += (index + 1) + "@";
            bettingString += (bet.Position || "") + "@";
            bettingString += (bet.BettingNumber || "") + "@";
            bettingString += bet.BettingMoney + "@";
            bettingString += bet.RangeValue + "@";
            bettingString += bet.BettingOdds + "@";
            bettingString += bet.Rebate + "|";
        });
        this.bettingMoneyCount.BettingItemString =
            bettingString.substr(0, bettingString.length - 1);
    }

    // 投注确认提交
    ReferResult() {
        if (!this.para.currIssue || this.para.currIssue.CurrentIssueNo == "-1") {
            this.alert.showAlert("当前彩种停盘中");
            return;
        }
        this.getBettingItemString();
        if (!this.bettingMoneyCount.BettingItemString) {
            this.alert.showAlert("投注内容为空，请重新选择投注项");
            return;
        }
        let ajaxList = [];
        let errors = [];
        this.bettingMoneyCount.BettingInfoIssueList = [];
        this.bettingMoneyCount.IsChaseNo = 0;
        this.bettingMoneyCount.IsStopAfterWinning = 0;
        this.bettingMoneyCount.IssueNo = this.para.currIssue.CurrentIssueNo;
        this.dollarsChaseArray(this.bettingMoneyCount.IssueNo, 1);
        let bettingInfo = this.bettingMoneyCount;
        bettingInfo.BettingInfoIssueList = [];
        bettingInfo.BettingItemList = [];
        ajaxList.push(this.bettingService.dollarBetting(bettingInfo));
        ajaxList.forEach(r => {
            r.then(s => {
                if (!s.Result) { errors.push(s); }
            });
        });
        this.submitBetting(ajaxList, errors,
            () => { this.close(true); }
        );

    }


    //确认投注ajax
    //tony 2017-12-22
    submitBetting(ajaxList, errors, fn) {
        let load = this.loadding.showLoding("投注中...");
        Promise.all(ajaxList).then(() => {
            if (errors.length > 0) {
                var errorhtml = [];
                errors.forEach(e => {
                    errorhtml.push(e.Error);
                });
                this.alert.showAlert(errorhtml.join(''));
            } else {
                fn();
                this.alert.showAlert("投注成功");
            }
            this.loadding.closeLoading(load);
        }).catch(c => {
            this.loadding.closeLoading(load);
        });
    }
    //开奖倒计时
    issueTimerCallback(time) {
        if (time > 0) {
            let t = PageDefault.formatTime(time / 1000);
            this.para.formatRemain = t.join(':');
        } else {
            clearInterval(this.setIntervalid);
            this.getIssue();
        }
    }
    //获取当前期号，当前期号结束剩余时间
    //2017-01-11
    getIssue() {
        this.bettingService.getIssue(this.bettingMoneyCount.LotteryCode).then(s => {
            this.para.currIssue = s;
            if (!s || s.CurrentIssueNo == "-1") {
                clearInterval(this.setIntervalid);
                this.para.formatRemain = "停盘中";
                return;
            }
            this.setIntervalid = setInterval(s => {
                this.para.currIssue.RemainTime -= 1000;
                this.issueTimerCallback(this.para.currIssue.RemainTime);
            }, 1000);
        });
    }
    //追号
    chaseClick() {
        if (this.bettingMoneyCount.BettingItemList.length <= 0) {
            this.alert.showAlert("投注列表没有可以追号的订单！");
            return;
        }
        this.getBettingItemString();
        var param = {
            playType: 1,
            currIssue: this.para.currIssue,
            lotteryCode: this.bettingMoneyCount.LotteryCode,
            bettingMoneyCount: this.bettingMoneyCount
        }
        this.navCtrl.push(BettingChase, param);
    }
}


// WEBPACK FOOTER //
// ./src/pages/dollars/bettingList.ts